import { useSessionStorage } from '@lib/hooks';
import { Currency } from '@lib/services';
export const getDefaultDetails = () => {
    return {
        total: 0,
        matchedAmount: 0,
        shareCode: '',
        email: '',
        matchPotBalance: 0,
        currency: Currency.GBP,
        firstName: '',
        lengthChoice: ''
    };
};
export const handleShare = (type, url) => {
    switch (type) {
        case 'whatsapp':
            window.open(`https://wa.me/?text=${encodeURIComponent(url)}`, '_blank');
            break;
        case 'facebook':
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
            break;
        case 'twitter':
            window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`, '_blank');
            break;
        case 'mail':
            window.open(`mailto:?subject=My Fridays&body=${encodeURIComponent(url)}`, '_blank');
            break;
    }
};
export const useSharePageDetails = () => {
    const [sharePageDetails, setSharePageDetails] = useSessionStorage('share_page_details', getDefaultDetails());
    return {
        sharePageDetails,
        setSharePageDetails
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmUuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic2VydmljZS9zaGFyZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxZQUFZLENBQUE7QUFFOUMsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGVBQWUsQ0FBQTtBQUV4QyxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxHQUFpQixFQUFFO0lBQ2xELE9BQU87UUFDTCxLQUFLLEVBQUUsQ0FBQztRQUNSLGFBQWEsRUFBRSxDQUFDO1FBQ2hCLFNBQVMsRUFBRSxFQUFFO1FBQ2IsS0FBSyxFQUFFLEVBQUU7UUFDVCxlQUFlLEVBQUUsQ0FBQztRQUNsQixRQUFRLEVBQUUsUUFBUSxDQUFDLEdBQUc7UUFDdEIsU0FBUyxFQUFFLEVBQUU7UUFDYixZQUFZLEVBQUUsRUFBRTtLQUNqQixDQUFBO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLENBQUMsSUFBa0QsRUFBRSxHQUFXLEVBQVEsRUFBRTtJQUNuRyxRQUFRLElBQUksRUFBRTtRQUNaLEtBQUssVUFBVTtZQUNiLE1BQU0sQ0FBQyxJQUFJLENBQUMsdUJBQXVCLGtCQUFrQixDQUFDLEdBQUcsQ0FBQyxFQUFFLEVBQUUsUUFBUSxDQUFDLENBQUE7WUFDdkUsTUFBSztRQUNQLEtBQUssVUFBVTtZQUNiLE1BQU0sQ0FBQyxJQUFJLENBQUMsZ0RBQWdELGtCQUFrQixDQUFDLEdBQUcsQ0FBQyxFQUFFLEVBQUUsUUFBUSxDQUFDLENBQUE7WUFDaEcsTUFBSztRQUNQLEtBQUssU0FBUztZQUNaLE1BQU0sQ0FBQyxJQUFJLENBQUMsd0NBQXdDLGtCQUFrQixDQUFDLEdBQUcsQ0FBQyxFQUFFLEVBQUUsUUFBUSxDQUFDLENBQUE7WUFDeEYsTUFBSztRQUNQLEtBQUssTUFBTTtZQUNULE1BQU0sQ0FBQyxJQUFJLENBQUMsbUNBQW1DLGtCQUFrQixDQUFDLEdBQUcsQ0FBQyxFQUFFLEVBQUUsUUFBUSxDQUFDLENBQUE7WUFDbkYsTUFBSztLQUNSO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsR0FBdUYsRUFBRTtJQUMxSCxNQUFNLENBQUMsZ0JBQWdCLEVBQUUsbUJBQW1CLENBQUMsR0FBRyxpQkFBaUIsQ0FBZSxvQkFBb0IsRUFBRSxpQkFBaUIsRUFBRSxDQUFDLENBQUE7SUFDMUgsT0FBTztRQUNMLGdCQUFnQjtRQUNoQixtQkFBbUI7S0FDcEIsQ0FBQTtBQUNILENBQUMsQ0FBQSJ9